<!--
 * @FileDescription: 往来单位的弹框（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-21（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
    <a-modal  v-model="isShowModel"  class="payment-model1"   :footer="null" :title="title"   @cancel="onCancel" >
       <a-form :form="form">
           <a-row :gutter="24" style="display: flex">
               <a-col :md="4" :sm="8" >
                   <a-form-item>
                       <a-select  v-decorator="['contactCustomerType',{ rules: [{ required: false}] },]"
                                  placeholder="供应商类别"
                                  style="width: 100%"
                       >
                           <a-select-option value="1">
                               供应商
                           </a-select-option>
                           <a-select-option value="0">
                               客户
                           </a-select-option>
                       </a-select>
                   </a-form-item>
               </a-col>
               <a-col :md="4" :sm="8" >
                   <a-form-item>
                       <a-input v-decorator="['keyword']" placeholder="请输入关键词查询"  style="width: 100%"/>
                   </a-form-item>
               </a-col>
               <a-col :md="6" :sm="8" >
                   <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
                   <a-button class="button-search1" @click.stop="onRest()">重置</a-button>
               </a-col>
               <a-col :md="10" :sm="8" style="line-height:30px;font-size:12px;font-weight:700">
                    <div class="receipt-top-right" @click="onbtnPage()">
                        <a-icon type="plus" style="color:#f76f14" />
                        <span class="text">新增往来单位</span>
                    </div> 
               </a-col>
           </a-row>
           <!-- <a-row v-if="warmPrompt">
                <span class="warm-prompt">温馨提示：更改往来单位，已选择的商品会被清除</span>
           </a-row> -->
       </a-form>
        <a-table :columns="columns"
                 :dataSource="dataSource"
                 @change="handleTableChange"
                 :pagination="pagination"
                 :scroll="{y:500 }"
                 :loading="loading"
                 :customRow="rowClick"
                 class="table-receipt"
                 bordered>
            <template  slot="operation" slot-scope="text, record, index">
                <a-button class="btn-save-next" v-if="!record.isCheck" @click.stop="onSelect(record,1)">选择</a-button>
                <a-input v-focus type="button" v-else class="btn-save-next btn-save-next-active" @click.stop="onSelect(record,2)" @pressEnter=" e =>handleEnter(e,record) " value="选中"></a-input>
            </template>
        </a-table>
    </a-modal>
    <unitModel ref="unitModel" :treeList="treeList"  @onPageList="onPageList"></unitModel>
  </div>
</template>
<script>
import {conditionList,getListPage,contactList} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from 'moment';
import pick from 'lodash.pick'
import ACol from "ant-design-vue/es/grid/Col";
import unitModel from '@/views/system/set/model/unitModel'
export default {
    mixins:[mixins],
    props:{
      up:{
          type:Number,
          default:38
      },
      down:{
          type:Number,
          default:40
      },
      warmPrompt: {
          type: Boolean,
          default: false
      }
    },
    data(){
        return{
            isShowModel:false,
            title:'往来单位',
            treeList:[],
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 45,
                    align: "center",
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '往来单位名称',
                    dataIndex: 'contactCustomerName',
                    key:'contactCustomerName',
                    ellipsis: true,
                },
                {
                    title: '往来单位类别',
                    dataIndex: 'contactCustomerType',
                    key:'contactCustomerType',
                    ellipsis: true,
                    customRender(t, r, index) {
                        if(t.charAt(0) == 0 && t.charAt(2) == 1){
                            return '客户，供应商'
                        }else if(t.charAt(0) == 0){
                           return '客户'
                       }else if(t.charAt(0) == 1){
                            return '供应商'
                       }
                    }
                },
                {
                    title: '联系人',
                    dataIndex: 'contactName',
                    key:'contactName',
                    ellipsis: true,
                },
                {
                    title: '联系电话',
                    dataIndex: 'mobile',
                    ellipsis: true,
                    key:'mobile',
                },
                {
                    title: '所在区域',
                    dataIndex: 'areaName',
                    ellipsis: true,
                    key:'areaName',
                },
                {
                    title: '操作',
                    width:100,
                    align:'center',
                    scopedSlots: { customRender: 'operation' },
                }
            ],
            dataSource:[],
            form: this.$form.createForm(this),
            stateIndex:0,
            inputValue:'',
            loading:true,
            isKeycode:false,
            selectIndex:0,
            isShow:false,
            contactCustomerId:'',
        }
    },
    mounted(){


    },
    updated(){
        let that = this
        if(that.isKeycode){
            document.onkeydown = function () {
                if(that.isKeycode){
                    if(window.event.keyCode == 40){
                        if(that.selectIndex == that.dataSource.length - 1){
                            return;
                        }
                        that.selectIndex += 1
                        that.dataSource.forEach((item,index)=>{
                            item.isCheck = false
                            if(this.contactCustomerId == item.id){
                                item.isCheck = true
                            }
                            if(index == that.selectIndex && that.isEmpty(that.contactCustomerId)){
                                item.isCheck = true
                            }
                        })
                    }
                    if(window.event.keyCode == 38){
                        if(that.selectIndex == 0){
                            return;
                        }
                        that.selectIndex -= 1
                        that.dataSource.forEach((item,index)=>{
                            item.isCheck = false
                            if(this.contactCustomerId == item.id){
                                item.isCheck = true
                            }
                            if(index == that.selectIndex && that.isEmpty(that.contactCustomerId)){
                                item.isCheck = true
                            }
                        })
                    }
                }
            }
        }
    },
    watch: {
    },
    created () {

    },
    components: {
        ACol,
        AFormItem,
        unitModel
    },
    methods: {
        getList(values){
            this.loading = true
            this.dataSource = []
            getListPage('/system/api/contactCustomer/listByConditions', {   companyStoreId:this.$store.state.shopId,
                pageNo:this.pagination.current,
                pageSize:this.pagination.pageSize,
                contactCustomerType:values.contactCustomerType,
                keyword:values.keyword,
            },{
                'Content-Type':'application/json'
            },{}).then((res) => {
                if (res.success) {
                    this.loading = false
                    if (res.result.total !== null && res.result.total !== 'null' && res.result.total !== "") {
                        res.result.total = parseInt(res.result.total)
                        res.result.current = parseInt(res.result.current)
                        res.result.pages = parseInt(res.result.pages)
                        res.result.size = parseInt(res.result.size)
                        this.pagination.total = res.result.total
                        this.pagination.current = res.result.current
                        this.pagination.current = res.result.current
                        this.pagination.pageSize = res.result.size
                    }
                    if (res.result.records.length > 0 && !this.isEmpty(res.result)) {
                        res.result.records.forEach((item,index) => {
                            item.isCheck = false
                            item.key = item.id
                            if(index == 0){
                                item.isCheck = true
                            }
                        })
                    }
                    this.dataSource = res.result.records
                } else {
                    this.$message.warn(res.logMessage)
                }
            })
        },
        //选择
        rowClick(record, index){
            return {
                on: {
                    dblclick:()=>{
                        record.isCheck = true
                        this.isShowModel = false
                        this.$emit('onSelectModel',record)
                    }
                }
            }
        },
        /**
        * @description: 此为方法注释（方法描述）
        */
        onOpen(inputValue,contactCustomerId){
            this.inputValue = inputValue
            this.isShowModel = true
            this.isKeycode = true
            if(this.isEmpty(inputValue)){
              this.getList({
                keyword: inputValue,
                contactCustomerType:''
              })
            }else{
              this.getList({
                keyword: inputValue.trim(),
                contactCustomerType:''
              })
            }
            this.form = this.$form.createForm(this)
            this.$nextTick(()=>{
                this.form.setFieldsValue({
                    keyword:inputValue,
                })
            })
            this.selectIndex = 0
            this.contactCustomerId = contactCustomerId
            setTimeout(()=>{
                this.isShow = true
                this.contactCustomerId = ''
            },300)
        },
        onCancel(){
          this.isKeycode = false
            this.isShowModel = false
            this.isShowModel1 = false
        },
        /**
         * @description: 选择类目（方法描述）
         */
        onSelect(record,index){
            if(index == 1){
                record.isCheck = true
                this.isShowModel = false
                this.$emit('onSelectModel',record)
            }else{
                this.isShowModel = false
                this.$emit('onSelectModel',record)
            }
        },
        onSearch(){
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.pagination.current = 1
                    this.getList(values)
                }
            })
        },
        onRest(){
           this.form = this.$form.createForm(this)
           this.pagination.current = 1
            this.getList({})
        },
        /**
         * @description: 分页（方法描述）
         */
        handleTableChange(pagination, filters, sorter){
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.selectIndex = 0
            let value = {}
            this.form.validateFields((err, values) => {
                if (!err) {
                    value = values
                }
            })
            this.getList(value)
        },
        handleEnter(e,item){
            this.isShowModel = false
            this.$emit('onSelectModel',item)
        },
        getDepartMessage(){
            let data = new FormData()
            data.append('companyStoreId',this.$store.state.shopId)
            contactList(data,{'Content-Type':'application/json'}).then((res)=>{
                if(res.success){
                    res.result.forEach((item)=>{
                        item.isCheck = false
                        item.isActive = false
                        item.name1 = item.name
                    })
                    this.treeList = res.result
                }
            })
        },
        onbtnPage(){
             this.getDepartMessage()
            // this.isShowModel = false
            // this.$router.push('/system/set/contactUnit')
            this.$refs.unitModel.onOpen(1,{})

        },
        onPageList(){
            if(this.isEmpty(this.inputValue)){
                 this.getList({
                    keyword: this.inputValue,
                    contactCustomerType:''
                })
            }else{
                 this.getList({
                    keyword: this.inputValue.trim(),
                    contactCustomerType:''
                })
            }
        }
    },

}
</script>
<style lang="scss">
    .payment-model1{
        width: 960px !important;
        height: 800px !important;
        .ant-modal-body{
            padding: 0 24px 24px;
        }
        .table-tr-active{
            background-color: pink;
        }
        .ant-table-tbody > tr > td{
            padding: 10px !important;
        }

        .table-receipt{
            .ant-table-body,.ant-table-body-inner{
                max-height: 500px !important;
            }
            .ant-table{
                height: 555px;
                .ant-table-body .ant-table-row{
                    height: 50px !important;
                }
            }
            .ant-table-body-inner{
                .ant-table-tbody > tr > td:nth-child(2){
                    border-right: none !important;
                }
            }
        }
    }
</style>
<style scoped lang="scss">
    .btn-save-next{
        width: 72px;
        height: 35px !important;
    }
    .btn-save-next-active{
        height: 35px !important;
        background: var(--co) !important;
        color: #fff;
        border: none !important;
    }
    .ant-form-horizontal{
        position: relative;
        padding-bottom: 10px;
    }
    .warm-prompt {
        position: absolute;
        height: 40px;
        line-height: 40px;
        padding-right: 16px;
        color: #f76f14;
        top: -30px;
        left: 0;
    }
    .receipt-top-right{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-weight: 700;
        .text{
            color: #f76f14;
            font-size: 14px;
            margin-left: 5px;
        }
    }
</style>
